import React from 'react'
import clientsList from '../data/clients.json'

// import imageSample from '../images/client-logos/ajanta.png'



import { Link } from 'react-router-dom'

import './styles/Clients.scss'

function Clients() {



    return (
        <div>
            {/* <img src={imageSample} alt="" srcset="" /> */}

            <h2>Нам доверяют:</h2>
            <br />
            <div className="clientsList">
                {clientsList.length > 0
                    ? clientsList.map((el, index) => {
                          return (
                              <Link key={index} className="clientsList__item" to={`/clients/${el.name}`}>
                                  {/* {el.name} */}
                                  <div
                                      className="clientsList-logo"
                                      style={{ backgroundImage: `url(${require(`../images/client-logos/${el.name}.png`)})` }}
                                  ></div>
                              </Link>
                          )
                      })
                    : 'Загружается список клиентов...'}
            </div>
        </div>
    )
}

export default Clients
